import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

const TimelineGraph = ({ filteredData, vehicleOptions, compressed }) => {
  // Calculate dynamic width: 150px per data point, minimum 100%
  const dynamicWidth = Math.max(100, (filteredData.length * 150) / 10);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      const vehicleName =
        vehicleOptions.find((v) => v.value === data.vehicle)?.label ||
        data.vehicle;

      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "4px",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
            width: "200px",
          }}
        >
          <div style={{ fontWeight: "bold" }}>{vehicleName}</div>
          <div style={{ marginTop: "5px", fontWeight: "bold" }}>Reason</div>
          <div style={{ color: "#ff6b6b" }}>{data.reason}</div>
          <div style={{ marginTop: "5px" }}>
            Time: {data.time.split("_")[0]}
          </div>
          <div>High Risk Score: {data.value}</div>
        </div>
      );
    }
    return null;
  };

  return (
    <div
      className="timeline-scroll"
      style={{
        width: "100%",
        height: compressed ? 250 : 400,
        transition: "0.3s ease",
      }}
    >
      {/* Container that grows based on data count */}
      <div
        style={{ width: `${dynamicWidth}%`, minWidth: "100%", height: "100%" }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={filteredData}
            // Give much more room on the left (for start of line) and right (for end of line)
            margin={{ top: 70, bottom: 90, left: 60, right: 80 }}
          >
            {/* 2. Fix Top Axis (Time) */}
            <XAxis
              xAxisId="top"
              dataKey="time"
              orientation="top"
              interval={0}
              height={80}
              axisLine={false}
              tickLine={false}
              tick={(props) => {
                const { x, y, payload } = props;
                return (
                  <text
                    x={x}
                    y={y - 25}
                    // Changed to 'middle' so it centers on the dot instead of starting there
                    textAnchor="middle"
                    fill="#666"
                    transform={`rotate(-35, ${x}, ${y - 25})`}
                    style={{ fontSize: "11px" }}
                  >
                    {payload.value.split("_")[0]}
                  </text>
                );
              }}
            />

            {/* 3. Fix Bottom Axis (Vehicle) */}
            <XAxis
              xAxisId="bottom"
              dataKey="vehicle"
              orientation="bottom"
              interval={0}
              height={100}
              axisLine={false}
              tickLine={false}
              tick={(props) => {
                const { x, y, payload } = props;
                const label =
                  vehicleOptions.find((v) => v.value === payload.value)
                    ?.label || payload.value;
                return (
                  <text
                    x={x}
                    y={y + 25}
                    // Changed to 'middle' to prevent the end of the text from sliding off-screen
                    textAnchor="middle"
                    fill="#666"
                    transform={`rotate(-35, ${x}, ${y + 25})`}
                    style={{ fontSize: "11px" }}
                  >
                    {label}
                  </text>
                );
              }}
            />

            <YAxis hide domain={[0, "dataMax + 20"]} />
            <Tooltip content={<CustomTooltip />} />
            <Line
              type="monotone"
              dataKey="value"
              stroke="#ff6b6b"
              strokeWidth={3}
              dot={{ r: 5, fill: "#ff6b6b", stroke: "#fff", strokeWidth: 2 }}
              activeDot={{ r: 8 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default TimelineGraph;
